import React from 'react';
import { animated, useTransition } from 'react-spring';
import fadeOverlayStyles from './fadeOverlay.module.pcss';

interface FadeOverlayProps {
  active: boolean;
}

function FadeOverlay({ active }: FadeOverlayProps): React.ReactElement {
  const overlayTransitions = useTransition(active, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 350 }
  });

  return (
    <>
      {overlayTransitions.map(
        ({ item: shouldShow, key, props }) =>
          shouldShow && <animated.div key={key} style={props} className={fadeOverlayStyles['fade-overlay']} />
      )}
    </>
  );
}

export default FadeOverlay;
